import io from 'socket.io-client';
import { setSocket } from '../store/slices/commonSlice';
import { getJwtToken, getUserId } from '../utils/api';

// Get socket server URL from WordPress localized data or use default
const getSocketServerUrl = () => {
    // Try to get from octopusReactData first
    if (typeof window.octopusReactData !== 'undefined' && window.octopusReactData.socketServerUrl) {
        return window.octopusReactData.socketServerUrl;
    }
    // Default fallback (should be set in PHP)
    return 'https://stagemy.instituteprojectmanagement.com';
};

export const connectSocket = () => async (dispatch, getState) => {
    const state = getState();
    const existingSocket = state.common?.socket;
    const currentUser = state.auth?.user;
    const userId = state.auth?.userId || getUserId();

    if (existingSocket && existingSocket.connected) {
        console.log('Socket already connected:', existingSocket.id);
        return existingSocket;
    }

    try {
        const token = getJwtToken();
        const socketServerUrl = getSocketServerUrl();
        
        
        if (!token) {
            console.warn('No JWT token available for socket connection');
            return null;
        }

        const socket = io(socketServerUrl, {
            path: "/backend/socket.io",
            transports: ['websocket'],
            auth: {
                token: token,
                user_id: userId,
            },
            reconnection: true,               
            reconnectionAttempts: 5,        
            reconnectionDelay: 2000,        
            reconnectionDelayMax: 5000  
        });

        socket.on('connect', () => {
            console.log('✅ Connected to the server:', socket.id);
            // Emit add-client with user data
            const userData = currentUser ? {
                id: currentUser.id || userId,
                from: 'website-react',
                ...currentUser
            } : {
                id: userId,
                from: 'website-react'
            };
            socket.emit('add-client', userData);
        });

        socket.on('disconnect', (reason) => {
            console.log('⚠️ Disconnected:', reason);
            if (reason === 'io server disconnect') {
                socket.connect(); 
            }
        });

        socket.on('connect_error', (error) => {
            console.log('❌ Connection error:', error);
        });

        // Dispatch socket to store - wrapped in try-catch to handle serialization issues
        try {
            dispatch(setSocket(socket));
        } catch (dispatchError) {
            console.error('Error dispatching socket to store:', dispatchError);
            // Store socket in a ref or window object as fallback if Redux fails
            if (typeof window !== 'undefined') {
                window.__octopusSocket = socket;
            }
        }

        return socket;
    } catch (error) {
        console.error('Error connecting to socket:', error);
        return null;
    }
};

export const disconnectSocket = () => (dispatch, getState) => {
    const socket = getState().common?.socket;

    if (socket) {
        socket.disconnect();
        dispatch(setSocket(null));
        console.log('👋 Disconnected from the server');
    }
};
